import { useState } from 'react';

/**
 * The latest defined value; kept while the value is undefined, and a value equal to it keeps its
 * reference, so readers render only on a real change.
 */
export function useRetainedValue<T>(
  value: T | undefined,
  isEqual: (retained: T, next: T) => boolean = Object.is
): T | undefined {
  const [retained, setRetained] = useState(value);
  if (value !== undefined && (retained === undefined || !isEqual(retained, value))) {
    setRetained(value);
    return value;
  }
  return retained;
}
